<st-clipboard
    #clipboard
    class="st-main-clipboard-container" />
@if (appSelectorVisible()) {
    <st-app-selector (toggleSideBar)="toggleSideNav()" />
}
<mat-sidenav-container
    class="st-main-container"
    [hasBackdrop]="false">
    @if (sideBarVisible()) {
        <mat-sidenav
            #sideNav
            class="st-main-sidebar-container"
            [mode]="sideNavMode()"
            [opened]="isSidenavOpened()">
            <st-side-bar (toggleSideBar)="toggleSideNav()" />
        </mat-sidenav>
    }
    @if (viewHasFilter()) {
        <mat-sidenav
            #filter
            position="end"
            class="st-main-filter-container"
            [mode]="filterElevation()"
            [opened]="isFilterOpened()"
            (openedChange)="filterOpenedChange($event)">
            @if (viewHasFilter()) {
                <st-filter (closeFilter)="filter.close()" />
            }
            @if (!viewHasFilter() && isCastView) {
                <st-cast-objects (closeCastObjects)="filter.close()" />
            }
        </mat-sidenav>
    }

    <mat-sidenav-content position="end">
        <div class="st-main-content-container">
            <st-top-bar
                (toggleFilter)="toggleFilter()"
                (toggleSideBar)="toggleSideNav()" />
            <st-main-content />
            <router-outlet />
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>
